import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import GridBase from "../ui/grid/grid-base.vue";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import { DxColumn } from "devextreme-vue/data-grid";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-company-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * Represents a company item with an ID and description.
   * Expected to be an object of type `IDDescriptionPair`.
   * @type {IDDescriptionPair}
   * @required
   */
  companies: {
    type: Array as PropType<IDDescriptionPair[]>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  "companySelected",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const selectedCompanyId = ref(0);
const gridKey = ref(0);

watch(
  () => showModal.value,
  () => {
    if (!showModal.value) {
      return;
    }

    selectedCompanyId.value = 0;
    gridKey.value++;
  },
);

const onCancelClick = () => (showModal.value = false);

const doubleClick = (company: IDDescriptionPair) => {
  if (!company) {
    return;
  }

  emit("companySelected", company.id);
  showModal.value = false;
};

const companySelected = (company: IDDescriptionPair) => {
  if (!company) {
    return;
  }

  selectedCompanyId.value = company.id;
};

const onSelectClick = () => {
  emit("companySelected", selectedCompanyId.value);
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
    height: "325px",
    title: "Companies",
    width: _unref(ModalWidth).XSmall
  }, {
    content: _withCtx(() => [
      (_openBlock(), _createBlock(GridBase, {
        key: gridKey.value,
        dataSource: props.companies,
        onRowClick: doubleClick,
        onRowSelected: companySelected,
        showColumnHeaders: false
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "id",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "description",
            caption: ""
          })
        ]),
        _: 1
      }, 8, ["dataSource"]))
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Select',
          onClick: () => {
            onSelectClick();
          },
          disabled: selectedCompanyId.value == 0,
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "width"]))
}
}

})